import { Box, Button } from '@mui/material'
import React, { useEffect, useState } from 'react'
import DropDownOA from '../../../common/dropDownOA'
import { Item } from '../../../common/snippets'
import { ReportHeading } from '../common/ReportHeading'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import * as id from '../reportId'
import * as lb from '../reportLables'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import Datepicker from '../../../common/datePicker'
import { focusElemnt, isEmpty, navigation3, removeDuplicatesFromArray } from '../../../common/helper'
import { RefreshSvg } from '../../../common/svg/refresh'
import {
  getCargoSettingFilterData,
  getFranchiseOutstandingTableData,
  getFranchiseOutstandingTableFiltersData,
} from '../../../../store/reports/reports_action'
import FranchiseOutstandingReportTable from './FranchiseOutstandingReportTable'
import { reportViewData } from './constants'
import FranchiseOutstandingReportDetailedTable from './FranchiseOutstandingReportDetailedTable'
import FranchiseOutstandingReportBothTable from './FranchiseOutstandingReportBothTable'
import { useAtom } from 'jotai'
import { alertAtom } from '../../../common/jotaiState/globalStateAtoms'
import { SELECT } from '../../../common/constants'
import { paymentModesWithAll } from '../../../common/paymentsMode'
import DropDownMultiSelectV2 from '../../../common/dropDownMultiSelectV2'


const FranchiseOutstandingReport = () => {
  const state = useSelector((state) => state)
  const { common, reports } = state
  const { loginData, roleRights,companySettings } = common
  const UseToPayAsCOD=companySettings[0]?.UseToPayAsCOD
  const { franchiseOutstandingTableFilterData, franchiseOutstandingTableData } = reports

  const dispatch = useDispatch()
  const {} = reports
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [showTable, setShowTable] = useState(false)
  const [, setAlert] = useAtom(alertAtom)

  const [tableData, setTableData] = useState([])
  const [disableGoBtn, setDisableGoBtn] = useState(false)
  const [tableDetailedData, setTableDetailedData] = useState([])
  const [disableBtn, setDisableBtn] = useState(false)
  const [disableExcel, setDisableExcel] = useState(false)
  const [sourceBranch, setSourceBranch] = useState('')
  const [selSourceCity, setSelSourceCity] = useState('')
  const [sourceCityData, setSourceCityData] = useState([])
  const [selSourceBranch, setSelSourceBranch] = useState('')
  const [sourceBranchDataAll, setSourceBranchDataAll] = useState([])
  const [sourceBranchData, setSourceBranchData] = useState([])
  const [selDestinationCity, setSelDestinationCity] = useState('')
  const [destinationCityData, setDestinationCityData] = useState([])
  const [selDestinationBranch, setSelDestinationBranch] = useState('')
  const [destinationBranchData, setDestinationBranchData] = useState([])
  const [destinationBranchDataAll, setDestinationBranchDataAll] = useState([])
  const paymentList = paymentModesWithAll.map((item) => {
    if (UseToPayAsCOD === 1) {
      if (item.typeId === 2) {
        return { ...item, name: 'COD' };
      }
      if (item.typeId === 7) {
        return { ...item, name: 'COD Manual' };
      }
      if (item.typeId === 9) {
        return { ...item, name: 'COD DDDV' };
      }
      if (item.typeId === 4) {
        return null;
      }
    }
    return { ...item, checked: true };
  }).filter(Boolean)
  // const paymentList = paymentModesWithAll.map((item) => ({ ...item, checked: true }))
  const [paymentType, setPaymentType] = useState(paymentList)
  const [reportView, setReportView] = useState(reportViewData?.[0])
  const reportName = 'Franchise Outstanding'
  const headerData = {
    company: loginData.strCompanyName,
    toDate: moment(toDate).format('DD-MMM-YYYY'),
    fromDate: moment(fromDate).format('DD-MMM-YYYY'),
    sourceCity: selSourceCity?.FranchiseeCityName,
    sourceBranch: selSourceBranch?.SourceBranch,
    destinationCity: selDestinationCity?.DestinationCity,
    destinationBranch: selDestinationBranch?.DestinationBranch,
    paymentType: paymentType.filter(p => p.checked).map(p => p.name).join(', '),
    reportView: reportView?.view,
  }

  const callFilterAPi = () => {
    if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      setAlert({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    } else {
      const obj = {
        CompanyID: loginData?.intCompanyID,
        FromDate: moment(fromDate).format('YYYY-MM-DD'),
        ToDate: moment(toDate).format('YYYY-MM-DD'),
      }
      dispatch(getFranchiseOutstandingTableFiltersData(obj))
    }
  }

  const reset = () => {
    setPaymentType(paymentList)
    setFromDate(moment(new Date()))
    setToDate(moment(new Date()))
    setSourceBranch(' ')
    setShowTable(false)
  }

  useEffect(() => {
    if (franchiseOutstandingTableData?.Data?.table?.length > 0 || franchiseOutstandingTableData?.Data?.table1?.length > 0) {
      const selectedTypes = paymentType.filter(p => p.checked).map((pt) => pt.typeId) || []
      const summaryTableData =franchiseOutstandingTableData?.Data?.table.map((item)=>({...item,PaymentType:UseToPayAsCOD===1&&item.PaymentTypeID===2?'COD':item.PaymentTypeID===7?'COD(MANUAL)':item.PaymentTypeID===9?'COD(DDDV)':item.PaymentType}))
        const detaileTableData =franchiseOutstandingTableData?.Data?.table1.map((item)=>({...item,PaymentType:UseToPayAsCOD===1&&item.PaymentTypeID===2?'COD':item.PaymentTypeID===7?'COD(MANUAL)':item.PaymentTypeID===9?'COD(DDDV)':item.PaymentType}))
      if (reportView.view !== 'Summary & Detailed') {
        let data = reportView.view === 'Summary' ? summaryTableData : detaileTableData
        let filtData = []
        if(selectedTypes.includes(0)){
          filtData = data
        }else{
          filtData = data.filter((item) => selectedTypes.includes(item.PaymentTypeID))
        }
        const filtPaymentTypeData = filtData.map((item) => ({
          ...item,
          isDataRow: true,
        }))

        setTableData(filtPaymentTypeData)
      } else {
        let summaryData = summaryTableData
        let detailedData = detaileTableData
        const filtSummaryData = selectedTypes.includes(0)
          ? summaryData
          : summaryData.filter((item) => selectedTypes.includes(item.PaymentTypeID))

        const filtDetailedData = selectedTypes.includes(0)
          ? detailedData
          : detailedData.filter((item) => selectedTypes.includes(item.PaymentTypeID))

        const mappedSummaryData = filtSummaryData.map((item) => ({
          ...item,
          isDataRow: true,
        }))

        const mappedDetailedData = filtDetailedData.map((item) => ({
          ...item,
          isDataRow: true,
        }))

        setTableData(mappedSummaryData)
        setTableDetailedData(mappedDetailedData)
      }

      setShowTable(true)
    }
  }, [franchiseOutstandingTableData])

  useEffect(() => {
    focusElemnt('fromDate')
  }, [])
  useEffect(() => {
    if (!isEmpty(loginData)) {
      const obj = {
        intCompanyID: loginData?.intCompanyID,
        intBranchID: loginData?.intBranchID,
        intUserID: loginData?.intUserID,
      }
      getCargoSettingFilterData(obj)
    }
  }, [loginData])
  useEffect(() => {
    if (!isEmpty(roleRights) && !isEmpty(loginData)) {
      setDisableBtn(
        !(
          roleRights?.Table1?.[0]?.AllowViewAllBranchReport ||
          roleRights?.Table1?.[0]?.AllowBranchInchargeRights ||
          loginData?.IsBranchAdmin ||
          loginData?.IsMTPLAdmin ||
          loginData?.IsAdmin
        )
      )
      setDisableExcel(!roleRights?.Table1?.[0]?.AllowExportExcel)
    }
  }, [roleRights, loginData])

  useEffect(() => {
    if (!isEmpty(franchiseOutstandingTableFilterData)) {
      if (franchiseOutstandingTableFilterData?.Data?.table?.length > 0) {
        let data = []
        let data1 = []
        let data2 = []
        let data3 = []
        const set1 = new Set()
        const set2 = new Set()
        const set3 = new Set()
        const set4 = new Set()
        franchiseOutstandingTableFilterData?.Data?.table?.map((val, i) => {
          if (!set1.has(val?.FranchiseeCityID)) {
            set1.add(val?.FranchiseeCityID)
            data.push({
              FranchiseeCityName: val?.FranchiseeCityName,
              FranchiseeCityID: val?.FranchiseeCityID,
              FranchiseComapnyID: val.FranchiseComapnyID,
            })
          }
          if (!set2.has(val?.FranchiseeBranchID)) {
            set2.add(val?.FranchiseeBranchID)
            data1.push({
              SourceBranch: val?.FranchiseeBranchName,
              FranchiseeBranchID: val?.FranchiseeBranchID,
              FranchiseeCityName: val?.FranchiseeCityName,
              SourceCityID: val?.FranchiseeCityID,
              FranchiseComapnyID: val.FranchiseComapnyID,
            })
          }
          if (!set3.has(val?.DestinationCityID)) {
            set3.add(val?.DestinationCityID)
            data2.push({
              DestinationCity: val?.DestinationCityName,
              DestinationCityID: val?.DestinationCityID,
              FranchiseeCityName: val.FranchiseeCityName,
              DestinationCompanyID: val.DestinationCompanyID,
            })
          }
          if (!set4.has(val?.DestinationBranchID)) {
            set4.add(val?.DestinationBranchID)
            data3.push({
              DestinationBranch: val?.DestinationBranchName,
              DestinationBranchID: val?.DestinationBranchID,
              DestinationCity: val?.DestinationCityName,
              DestinationCompanyID: val.DestinationCompanyID,
              DestinationCityID: val?.DestinationCityID,
            })
          }
        })
        if (data.length > 1) {
          data.unshift({ FranchiseeCityName: 'All Cities', FranchiseeCityID: 0 })
        }
        setSourceCityData(data)
        const data1filter = data1.filter((item) => item?.FranchiseComapnyID !== loginData?.intCompanyID)
        setSourceBranchData(data1filter)
        if (data1.length > 1) {
          data1.unshift({ SourceBranch: 'All Branches', FranchiseeBranchID: 0 })
        }
        setSourceBranchDataAll(data1)
        setDestinationCityData([{ DestinationCity: 'All Cities', DestinationCityID: 0 }, ...data2])
        const data3filter = data3.filter((item) => item?.DestinationCompanyID !== loginData?.intCompanyID)
        setDestinationBranchData(data3filter)
        if (data3.length > 1) {
          data3.unshift({ DestinationBranch: 'All Branch', DestinationBranchID: 0 })
        }
        setDestinationBranchDataAll(data3)
        if (disableBtn) {
          setSelSourceCity({ FranchiseeCityName: loginData?.strCityName, FranchiseeCityID: loginData?.intBranchCityID })
          setSelSourceBranch({ SourceBranch: loginData?.strBranchName, FranchiseeBranchID: loginData?.intBranchID })
        } else {
          setSelSourceCity({ FranchiseeCityName: 'All Cities', FranchiseeCityID: 0 })
          data1.length > 1
            ? setSelSourceBranch({ SourceBranch: 'All Branches', FranchiseeBranchID: 0 })
            : data1.length === 1
            ? setSelSourceBranch(data1[0])
            : setSelSourceBranch('')
        }
        setSelDestinationCity({ DestinationCity: 'All Cities', DestinationCityID: 0 })
        setSelDestinationBranch({ DestinationBranch: 'All Branch', DestinationBranchID: 0 })
      } else {
        setSourceCityData([])
        setSourceBranchData([])
        setDestinationCityData([])
        setDestinationBranchData([])
        setSelSourceCity(' ')
        setSelSourceBranch(' ')
        setSelDestinationCity('  ')
        setSelDestinationBranch(' ')
      }
    }
  }, [franchiseOutstandingTableFilterData])

  const handleClick1 = () => {
    if (selSourceCity == '' || selSourceCity == ' ') {
      setAlert({ show: true, msg: 'Select Source City', nextId: '' })
    }
    if (selSourceBranch == '' || selSourceBranch == ' ' || selSourceBranch == undefined) {
      setAlert({ show: true, msg: 'Select Source Branch', nextId: '' })
    } else if (selDestinationBranch == '' || selDestinationBranch == ' ' || selDestinationBranch == undefined) {
      setAlert({ show: true, msg: 'Select Source Branch', nextId: '' })
    } else if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      setAlert({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    } else if (franchiseOutstandingTableFilterData?.Data?.table?.length > 0) {
      const body = {
        CompanyID: loginData?.intCompanyID,
        FromDate: moment(fromDate).format('YYYY-MM-DD'),
        ToDate: moment(toDate).format('YYYY-MM-DD'),
        FranchiseCityID: selSourceCity?.FranchiseeCityID,
        FranchiseBranchID: selSourceBranch?.FranchiseeBranchID,
        ToCityID: selDestinationCity?.DestinationCityID,
        ToBranchID: selDestinationBranch?.DestinationBranchID,
      }
      dispatch(getFranchiseOutstandingTableData(body))
    }
  }
  const selectedReportView = (value) => {
    setReportView(value)
    setShowTable(false)
  }

  const selectedSourceCity = (obj) => {
    setSelSourceCity(obj)
    if (obj.FranchiseeCityID) {
      const tempList = sourceBranchData.filter((a) => a.SourceCityID === obj?.FranchiseeCityID)
      setSelSourceBranch(tempList?.[0] || '')
      if(obj.FranchiseeCityID===selDestinationCity?.DestinationCityID){
        selectedDestCity('')
      }
    }else{
      setSelSourceBranch(sourceBranchDataAll?.[0]||'')
    }
    setShowTable(false)
  }
  const selectedDestCity = (obj) => {
    setSelDestinationCity(obj)
    if(obj.DestinationCityID){
      const tempList = destinationBranchData.filter(a=>a.DestinationCityID===obj?.DestinationCityID)
      setSelDestinationBranch(tempList?.[0]||'')
    }else{
      setSelDestinationBranch(destinationBranchDataAll?.[0]||'')
    }
    setShowTable(false)
  }

  useEffect(() => {
    focusElemnt(id.fromDate)
  }, [])
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        <ReportHeading reportName={reportName} />
        <Box sx={sx.reportFlex}>
          <Item sx={sx.itemsx} style={{ width: '350px' }}>
            <DropDownOA
              id={id.selectCompnay}
              label={lb.select_company}
              defaultvalue={loginData.strCompanyName}
              disabled={true}
              width="100%"
            />{' '}
          </Item>
          <Item sx={sx.itemsx} style={{ width: '250px' }} className="input--container bookingDatePicker">
            <Datepicker
              name={'from_collection_date'}
              value={fromDate}
              label={'From Date'}
              id={id.fromDate}
              dateChange={(date) => {
                setFromDate(date)
                setShowTable(false)
                focusElemnt(id.toDate)
              }}
              width="100%"
              dateDiff={730}
            />
          </Item>
          <Item sx={sx.itemsx} style={{ width: '250px' }} className="input--container bookingDatePicker">
            <Datepicker
              label={'To Date'}
              value={toDate}
              id={id.toDate}
              dateChange={(date) => {
                setToDate(date)
                setShowTable(false)
                focusElemnt(id.anSourceCity)
              }}
              width="100%"
              dateDiff={730}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <Button
              variant="contained"
              style={{ ...sx.fullHeight, ...sx.novp }}
              id={id.goButton}
              disabled={disableGoBtn}
              className="btn btn-primary"
              onClick={callFilterAPi}
            >
              GO
            </Button>
          </Item>
          <Item sx={sx.itemsx} style={{ width: '300px' }}>
            <DropDownOA
              id={id.anSourceCity}
              label={'Source City'}
              searchPlaceholder={`Search Source City`}
              defaultvalue={selSourceCity?.FranchiseeCityName || SELECT}
              data={sourceCityData || []}
              listWidth="200px"
              width="100%"
              dataKey={`FranchiseeCityName`}
              idKey={`FranchiseeCityID`}
              disabled={disableBtn}
              onSelect={(obj) => selectedSourceCity(obj)}
              nextId={id.anSourceBranch}
              prevId={id.toDate}
            />
          </Item>
          <Item sx={sx.itemsx} style={{ width: '300px' }}>
            <DropDownOA
              id={id.anSourceBranch}
              label={'Source Branch'}
              searchPlaceholder={`Search Source Branch`}
              defaultvalue={selSourceBranch?.SourceBranch || SELECT}
              data={
                selSourceCity?.FranchiseeCityID
                  ? sourceBranchData.filter(
                      (a) =>
                        a.SourceCityID === selSourceCity?.FranchiseeCityID && a.FranchiseComapnyID === selSourceCity?.FranchiseComapnyID
                    )
                  : sourceBranchDataAll || []
              }
              width="100%"
              listWidth="200px"
              dataKey={`SourceBranch`}
              idKey={`FranchiseeBranchID`}
              disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0}
              onSelect={(obj) => {
                setSelSourceBranch(obj)
                setShowTable(false)
              }}
              nextId={id.anDestinationCity}
              prevId={id.anSourceCity}
            />
          </Item>
          <Item sx={sx.itemsx} style={{ width: '250px' }}>
            <DropDownOA
              id={id.anDestinationCity}
              label={'Destination City'}
              searchPlaceholder={`Search Destination City`}
              defaultvalue={selDestinationCity?.DestinationCity || SELECT}
              data={destinationCityData.filter((a) => a.DestinationCityID !== selSourceCity?.FranchiseeCityID || !a.DestinationCityID)}
              width="100%"
              listWidth="200px"
              dataKey={`DestinationCity`}
              idKey={`DestinationCityID`}
              onSelect={(obj) => selectedDestCity(obj)}
              nextId={id.anDestinationCity}
              prevId={id.anSourceBranch}
            />
          </Item>

          <Item sx={sx.itemsx} style={{ width: '250px' }}>
            <DropDownOA
              id={id.anDestinationBranch}
              defaultvalue={selDestinationBranch?.DestinationBranch || SELECT}
              data={
                selDestinationCity?.DestinationCityID
                  ? destinationBranchData
                      .filter(
                        (a) =>
                          a.DestinationCityID === selDestinationCity?.DestinationCityID &&
                          a.DestinationCompanyID === selDestinationCity?.DestinationCompanyID
                      )
                  : destinationBranchDataAll.filter((a) => a.DestinationCityID !== selSourceCity?.FranchiseeCityID) || []
              }
              width="100%"
              searchPlaceholder={`Search Destination Branch`}
              label={'Destination Branch'}
              tabIndex="2"
              dataKey={`DestinationBranch`}
              idKey={`DestinationBranchID`}
              onSelect={(value) => {
                setSelDestinationBranch(value)
                setShowTable(false)
              }}
              nextId={id.anPaymentType}
              prevId={id.anDestinationCity}
            />
          </Item>
          <Item sx={sx.itemsx} style={{ width: '205px' }}>
            <DropDownMultiSelectV2
              id={id.anPaymentType}
              data={paymentList || []}
              defaultvalue={paymentType}
              width="100%"
              searchPlaceholder={`Search By Payment Type`}
              label={'Payment Type'}
              tabIndex="2"
              dataKey={`name`}
              HasAllSelect={true}
              idKey={`typeId`}
              onSelect={(value) => {
                setShowTable(false)
                setPaymentType(value)
              }}
              nextId={id.anView}
              prevId={id.anDestinationBranch}
            />
          </Item>
          <Item sx={sx.itemsx} style={{ width: '250px' }}>
            <DropDownOA
              id={id.anView}
              defaultvalue={reportView?.view}
              data={reportViewData}
              width="100%"
              searchPlaceholder={`Search By View`}
              label={'Report View'}
              tabIndex="2"
              dataKey={`view`}
              idKey={`id`}
              onSelect={(value) => selectedReportView(value)}
              nextId={'SplitButton'}
              prevId={id.anPaymentType}
            />
          </Item>
          <Item
            sx={sx.itemsx}
            onKeyDown={(e) =>
              navigation3(e, showTable ? (disableExcel ? 'ExportToPdf' : 'ExportToExl') : id.fromDate, id.anView, () => handleClick1())
            }
          >
            <Button
              variant="contained"
              id={'SplitButton'}
              onClick={handleClick1}
              className="btn btn-primary"
              style={{ padding: '7px 10px' }}
            >
              GENERATE NEW FORMAT
            </Button>
          </Item>
          <Item sx={{ ...sx.itemsx }} style={{ cursor: 'pointer' }} onClick={() => reset()}>
            <RefreshSvg width={'24px'} height={'24px'} />
          </Item>
        </Box>
      </Item>
      <Item>
        {showTable &&
          (() => {
            const CommonProps = {
              disableExcel,
              headerData,
              tablesData: tableData || [],
              sourceBranch,
            }

            return reportView.view === 'Summary' ? (
              <FranchiseOutstandingReportTable {...CommonProps} UseToPayAsCOD={UseToPayAsCOD} />
            ) : reportView.view === 'Detailed' ? (
              <FranchiseOutstandingReportDetailedTable {...CommonProps} />
            ) : (
              <FranchiseOutstandingReportBothTable {...CommonProps} UseToPayAsCOD={UseToPayAsCOD} tablesDataDetailed={tableDetailedData} />
            )
          })()}
      </Item>
    </>
  )
}

export default FranchiseOutstandingReport
